import { paths } from "@config/paths";
import { redirect, type LoaderFunction } from "react-router";

export const v2RedirectLoader: LoaderFunction = ({ request }) => {
  const { pathname, search, hash } = new URL(request.url);

  // Removes the v2 from the start of the path.
  const newPath = pathname.slice(3) || paths.root.path;

  return redirect(newPath + search + hash);
};
